module.exports = __webpack_public_path__ + "static/media/29COICT9.23ff4411.jpg";